import { z } from 'zod';
import { playerAnalyticsSchema } from '@playcastdotio/AnalyticsCore';

export const milestonePageLoadedSchema = playerAnalyticsSchema.extend({
  name: z.literal('Milestone Page Loaded'),
  eventId: z.literal('milestone_page_loaded'),
  campaignId: z.string(),
  pageLoadTime: z.number().optional(),
});

export const milestoneStreamRenderedSchema = playerAnalyticsSchema.extend({
  name: z.literal('Milestone Stream Rendered'),
  eventId: z.literal('milestone_stream_rendered'),
  campaignId: z.string(),
  connectionDurationMs: z.number().optional(),
});

export const milestoneFirstInputSchema = playerAnalyticsSchema.extend({
  name: z.literal('Milestone First Input'),
  eventId: z.literal('milestone_first_input'),
  campaignId: z.string(),
});

export type MilestonePageLoaded = z.infer<typeof milestonePageLoadedSchema>;
export type MilestoneStreamRendered = z.infer<typeof milestoneStreamRenderedSchema>;
export type MilestoneFirstInput = z.infer<typeof milestoneFirstInputSchema>;
